<template>
  <div class="congress-bill">
    <div class="background-container">
      <div class="about-title">
        국회의원 1호법안 상황판<span class="about-title-dot"></span>
      </div>
    </div>

    <div class="national-content">
      <div class="national-content-inner">
        <!--  -->
        <div class="search-inner">
          <div class="search-wrap">
            <input
              placeholder="의원명"
              v-model="searchInput"
              @keyup="bindEnter"
              class="search"
            />
            <button @click="searchCongressman" class="search-btn" type="button">
              <img
                :src="require('../assets/img/search.png')"
                alt="검색아이콘"
              />
            </button>
          </div>
        </div>
        <!--  -->
        <div class="page-description">
          <div>업데이트 날짜: {{ lastUpdatedAt }} (업데이트 주기: 1시간)</div>
          <br />
          <span class="blue-text"
            ><img
              :src="require('../assets/img/horizontal-scroll-icon.png')"
              alt="좌우 스크롤 아이콘"
            />좌우로 스크롤</span
          >하여 상황판을 확인해보세요.
        </div>
        <!--  -->
        <div
          class="table-wrap"
          id="tableWrap"
          :style="
            congressmanBillDataList.length !== originData.length
              ? 'margin-bottom: 50px;'
              : 'margin-bottom: 100px;'
          "
        >
          <table class="national-table">
            <thead>
              <tr>
                <th :style="`top: ${top}px`">순번</th>
                <th :style="`top: ${top}px`">의원명</th>
                <th :style="`top: ${top}px`">소속정당</th>
                <th :style="`top: ${top}px`">지역구</th>
                <th :style="`top: ${top}px`">1호법안</th>
                <th :style="`top: ${top}px`">소관위</th>
                <th :style="`top: ${top}px`">제안일</th>
                <th :style="`top: ${top}px`">소관위 상정일</th>
                <th :style="`top: ${top}px`">소관위 처리일</th>
                <th :style="`top: ${top}px`">소관위 처리결과</th>
                <th :style="`top: ${top}px`">법사위 회부일</th>
                <th :style="`top: ${top}px`">법사위 상정일</th>
                <th :style="`top: ${top}px`">법사위 처리일</th>
                <th :style="`top: ${top}px`">본회의 의결일</th>
                <th :style="`top: ${top}px`">본회의 심의결과</th>
                <th :style="`top: ${top}px`">잠자는 시간</th>
              </tr>
            </thead>
            <tr v-for="(item, index) in congressmanBillDataList" :key="index">
              <td>{{ index + 1 }}</td>
              <!-- 의원명 -->
              <td>{{ item?.RST_PROPOSER }}</td>
              <!-- 소속정당 -->
              <td>{{ item?.POLY_NM }}</td>
              <!-- 지역구 -->
              <td>{{ item?.ORIG_NM }}</td>
              <!-- 1호법안 -->
              <td>
                <a :href="item?.DETAIL_LINK" class="link" target="_blank">{{
                  item?.BILL_NAME
                }}</a>
              </td>
              <!-- 소관위 -->
              <td>{{ item?.COMMITTEE }}</td>
              <!-- 제안일 -->
              <td>{{ item?.PROPOSE_DT }}</td>
              <!-- 소관위 상정일 -->
              <td>{{ item?.CMT_PRESENT_DT }}</td>
              <!-- 소관위 처리일 -->
              <td>{{ item?.CMT_PROC_DT }}</td>
              <!-- 소관위 처리 결과 -->
              <td>{{ item?.CMT_PROC_RESULT_CD }}</td>
              <!-- 법사위 회부일 -->
              <td>{{ item?.LAW_SUBMIT_DT }}</td>
              <!-- 법사위 상정일 -->
              <td>{{ item?.LAW_PRESENT_DT }}</td>
              <!-- 법사위 처리일 -->
              <td>{{ item?.LAW_PROC_DT }}</td>
              <!-- 본회의 의결일 -->
              <td>{{ item?.PROC_DT }}</td>
              <!-- 본회의 심의결과 -->
              <td>{{ item?.PROC_RESULT }}</td>
              <td>{{ item?.SLEEPING_DAY ? item?.SLEEPING_DAY + "일" : "" }}</td>
            </tr>
          </table>
        </div>
        <div
          class="search-btn-rollback-wrap"
          v-if="congressmanBillDataList.length !== originData.length"
        >
          <button type="button" class="rollback-btn" @click="rollback">
            <img class="pc" :src="require('../assets/img/all-list-icon.png')" />
            <img
              class="mobile"
              width="30"
              :src="require('../assets/img/all-list-icon-m.png')"
            />
            <span>전체 목록 상황판</span>
          </button>
        </div>

        <!--  -->
        <div class="congressman-page-description">
          <div class="title">[1호법안 선정 기준]</div>
          <div class="sub">
            ▶22대 국회 개원 후 최초 발의한 법안(공동 대표발의는 제외)<br />
            ▶같은 날 복수의 법안을 발의한 경우, 국회 접수 선순위 법안<br />
            ▶1호 법안을 철회했을 경우, 차순위 법안을 선정
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CongressmanBillPage",

  data() {
    return {
      originData: [],
      congressmanBillDataList: [],
      searchInput: "",
      lastUpdatedAt: null,
      top: 0,
      isPc: true,
    };
  },

  mounted() {
    this.getCongressmanBillData();
    this.checkScreenWidth();

    window.addEventListener("resize", this.checkScreenWidth);
    console.log("this.isPc", this.isPc);
    if (this.isPc) {
      document
        .getElementById("tableWrap")
        .addEventListener("scroll", this.changeScroll);
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenWidth);

    document
      .getElementById("tableWrap")
      .removeEventListener("scroll", this.changeScroll);
  },

  methods: {
    checkScreenWidth() {
      this.isPc = window.innerWidth > 1040;
    },
    changeScroll() {
      const headerHeight = document.getElementById("headerWrap").clientHeight;

      if (document.getElementById("tableWrap").scrollTop > headerHeight) {
        this.top = document.getElementById("tableWrap").scrollTop;
      } else {
        this.top = 0;
      }
    },
    async getCongressmanBillData() {
      try {
        const res = await axios.get(
          process.env.VUE_APP_TRAGET_URL + "/assembly/bill/first"
        );

        if (typeof res.data.list !== "undefined") {
          this.originData = res.data.list;
          this.lastUpdatedAt = res.data.updatedAt;
          this.congressmanBillDataList = [...this.originData];
        }
      } catch (exception) {
        console.error(`[getCongressmanBillData] - exception ${exception}`);
        alert("데이터 요청에 실패했습니다. 하단 이메일로 문의해주세요.");
      }
    },
    rollback() {
      this.searchInput = "";
      this.searchCongressman();
    },
    bindEnter(event) {
      if (event.key === "Enter") {
        this.searchCongressman();
      }
    },
    searchCongressman() {
      if (this.searchInput.length === 0) {
        this.congressmanBillDataList = [...this.originData];
        return;
      }

      this.congressmanBillDataList = this.originData.filter((item) => {
        return item?.RST_PROPOSER.includes(this.searchInput);
      });
    },
  },
};
</script>

<style scoped>
.congress-bill {
  @media only screen and (max-width: 1040px) {
    background: #f6f6f6;
  }
}

.background-container {
  background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url("../assets/img/congressman.jpg");
  background-size: cover;
  background-position: -200px bottom;
  background-attachment: fixed;
  height: 600px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  @media only screen and (max-width: 1040px) {
    background-attachment: initial;
  }
}

.about-title {
  position: relative;
  font-family: GmarketSansMedium;
  font-size: 70px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;

  @media only screen and (max-width: 1040px) {
    padding: 0 30px;
    font-size: 7vw;
  }
}

.about-title-dot {
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #005aab;
  border-radius: 50%;
  right: -20px;
  top: -20px;

  @media only screen and (max-width: 1040px) {
    right: 0;
  }
}

.national-menu {
  position: absolute;
  bottom: 0;
  height: 80px;
  background-color: #000;
  width: 100%;
  display: flex;
  justify-content: center;
}

.national-menu-item {
  width: 511px;
  justify-content: center;
  font-family: GmarketSansMedium;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  justify-content: center;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
}

.national-menu-item.active {
  background-color: #fff;
  color: #000;
  border-radius: 20px 20px 0 0;
  opacity: 1;
}

.national-content {
  margin: 100px 0 0 0;
  display: flex;
  justify-content: center;
}

.national-content-inner {
  max-width: 1320px;
  width: 100%;
  padding: 0 30px;
}

.search-inner {
  text-align: right;

  @media only screen and (max-width: 1040px) {
    text-align: center;
  }
}

.link {
  color: #000;
  width: 100%;
  padding: 5px 0;
  display: inline-block;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
}

.search-wrap {
  width: 280px;
  height: 50px;
  border-radius: 10px;
  border: solid 1px #d8d8d8;
  background-color: #fff;
  display: inline-flex;
  align-items: center;

  @media only screen and (max-width: 1040px) {
    width: 100%;
    border: none;
    background: transparent;
  }
}

.search-btn-rollback-wrap {
  text-align: center;
  margin-bottom: 50px;
}

.rollback-btn {
  width: 211px;
  height: 50px;
  padding: 17px 29px 18px 30px;
  border-radius: 10px;
  border: solid 1px #0db2ab;
  background-color: #0db2ab;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: space-around;
  font-size: 16px;

  & img.mobile {
    display: none;
  }

  @media only screen and (max-width: 1040px) {
    & img.pc {
      display: none;
    }

    & img.mobile {
      display: inline-flex;
    }

    & {
      gap: 10px;
      width: 100%;
      justify-content: center;
      border-radius: 0;
      font-size: 20px;
    }
  }
}

.search {
  width: 200px;
  height: 50px;
  line-height: 50px;
  border-radius: 10px 0 0 10px;
  border-left: solid 1px #d8d8d8;
  border-top: solid 1px #d8d8d8;
  border-bottom: solid 1px #d8d8d8;
  font-family: GmarketSansMedium;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  border-right: none;
  padding-left: 30px;
  background-color: transparent;

  @media only screen and (max-width: 1040px) {
    width: 100%;
    border-radius: 0;
    background-color: #fff;
  }

  &::placeholder {
    color: #989898;
  }
}

.search-btn {
  width: 80px;
  text-align: center;
  border-radius: 0 10px 10px 0;
  height: 50px;
  border: solid 1px #004786;
  background-color: #005aab;

  @media only screen and (max-width: 1040px) {
    border-radius: 0;
  }
}

.page-description {
  margin-top: 13px;
  margin-bottom: 19px;
}

.blue-text {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  vertical-align: middle;
  color: #005aab;
}

.national-table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  border-collapse: collapse;
  overflow: hidden;
  border-style: hidden;
  box-shadow: 0 0 0 1px #cacaca;

  & th {
    padding: 21px 0;
    border: 1px solid #cacaca;
    background-color: #005aab;
    font-family: GmarketSansMedium;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    position: sticky;
  }

  & td {
    min-width: 200px;
    padding: 21px 0;
    border: 1px solid #cacaca;
    font-family: GmarketSansMedium;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000;
    vertical-align: middle;
  }

  & tr:nth-child(2n + 1) {
    background-color: #f5f5f5;
  }

  & tr td.red {
    color: #de0000;
    text-decoration: underline;
    cursor: pointer;
  }

  & tr td.blue {
    color: #005aab;
    text-decoration: underline;
    cursor: pointer;
  }

  & td:first-child {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
    word-break: break-all;
  }

  @media only screen and (max-width: 1040px) {
    background-color: #fff;
  }
}

.national-table.sub-auto {
  table-layout: fixed;

  & .sky {
    background-color: #e7f4ff;

    & td {
      color: #005aab;
      width: auto !important;
    }
  }

  & td {
    width: auto;
    max-width: 10px !important;
    vertical-align: middle;
  }

  & tr td:nth-child(n + 2) {
    width: 100px;
  }

  .not {
    width: auto !important;
  }
}

.table-wrap {
  width: 100%;
  overflow-x: scroll;
  border-left: 1px solid #cacaca;
  border-right: 1px solid #cacaca;
  border-bottom: 1px solid #cacaca;
  margin-bottom: 100px;
  max-height: 500px;
  overflow-y: scroll;

  @media only screen and (max-width: 1040px) {
    max-height: inherit;
    overflow-y: inherit;
  }
}

.congressman-page-description {
  padding: 30px;
  background-color: #e0e0e0;
  margin-bottom: 100px;
}

.congressman-page-description .title {
  font-family: GmarketSansMedium;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666;
  margin-bottom: 19px;
}

.congressman-page-description .sub {
  font-family: GmarketSansMedium;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666;
}
</style>
